/**
* 底部
* Created by dxw on 2020/03/17.
*/
<template>
  <div class="login-footer">
    <div class="footer-content">
      <ul>
        <li>关于我们</li>
        <li>|</li>
        <li>关于我们</li>
        <li>|</li>
        <li>帮助中心</li>
        <li>|</li>
        <li>隐私保护</li>
        <li>|</li>
        <li>广告服务</li>
        <li>|</li>
        <li>联系我们</li>
        <li>|</li>
        <li>采购指南</li>
        <li>|</li>
        <li>用户协议</li>
        <li>|</li>
        <li>基础功能</li>
        <li>|</li>
        <li>友情链接</li>
        <li>|</li>
        <li>产品中心</li>
        <li>|</li>
        <li>订单操作</li>
      </ul>
      <div>
        Copyright © 2020-现在 Jianglaiwang (Shanghai) E-commerce Co., Ltd. All Rights Reserved
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'footer',
    data() {
      return {}
    }
  }
</script>


<style lang="stylus" type="text/stylus">
  .login-footer
    width 100%
    height 280px
    color #606060
    background-color #ffffff
    font-size 14px
    padding-top 20px
    .footer-content
      width 1200px
      margin 0 auto

      ul
        list-style none
        display flex
        justify-content center
        margin-bottom 12px
        li
          margin-right 10px
      div
        text-align center


</style>



// WEBPACK FOOTER //
// src/common/footer/footer.vue